import { useEffect } from "react";
import { useUser } from "@clerk/clerk-react";
import { isUserAdmin, isUserAgentEditor } from "@/utils/roles";

interface AdminAuthProviderProps {
  children: React.ReactNode;
}

export const AdminAuthProvider = ({ children }: AdminAuthProviderProps) => {
  const { user } = useUser();

  useEffect(() => {
    const checkUserPermissions = async () => {
      const isUserAdminOrEditor = isUserAdmin(user) || isUserAgentEditor(user);
      if (!isUserAdminOrEditor) {
        window.location.href = "https://dashboard.loman.ai";
      }
    };
    checkUserPermissions();
  }, [user]);

  return <>{children}</>;
};
